export default {"src":"/_next/static/media/decision.7aca131f.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};